export enum EcallStatus {
  created = 0,
  received = 1,
  arrived = 2,
  completed = 3,
  cancelled = 4
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/ecall-status.ts